import React from 'react';
import { Stack } from '@mui/material';

const ReservationHeader = () => {
  return <Stack className="bg-transparent w-full h-full" style={{ minHeight: '2rem' }}></Stack>;
};

export default ReservationHeader;
